var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedSpinner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M7,0 L7.14829272,0.0015430376 C10.9517693,0.0807577918 14,3.18933049 14,7 C14,10.8659932 10.8659932,14 7,14 C6.57044519,14 6.22222222,13.651777 6.22222222,13.2222222 C6.22222222,12.7926674 6.57044519,12.4444444 7,12.4444444 C10.0068836,12.4444444 12.4444444,10.0068836 12.4444444,7 C12.4444444,4.09929871 10.1733161,1.72149465 7.3038711,1.56387568 L7,1.55555556 C3.99311636,1.55555556 1.55555556,3.99311636 1.55555556,7 C1.55555556,7.42955481 1.20733258,7.77777778 0.777777778,7.77777778 C0.348222972,7.77777778 0,7.42955481 0,7 C0,3.13400675 3.13400675,0 7,0 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    fill: "#C60000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#C60000",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedSpinner);
export default __webpack_public_path__ + "static/media/red_spinner.5f33cecc44f75b121c2ab6b355dc02a5.svg";
export { ForwardRef as ReactComponent };